<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_9">CHAPTER</a></h2><a id="page_9">
<h2 class="h2n"><img alt="Images" class="mid" src="images/common.jpg"/> 2 <img alt="Images" class="mid" src="images/common1.jpg"/></h2>
<p class="noindent"><span class="font1">As soon as we pulled</span> up to the rescue center, all we could see were happy dog faces and wagging tails. Dogs were everywhere! It was the coolest thing ever.</p>
</a><p class="indent"><a id="page_9">There was a woman standing outside the door holding about a billion leashes. Each one had a dog attached to it. There were little dogs and big dogs and black dogs and tan dogs. There </a><a id="page_10">were dogs with lots of fur and dogs without much fur at all. I wanted to hug them all!</a></p><a id="page_10">
<p class="indent">“Mom!” I called out as we got closer. She could see the same thing I was seeing, but she didn’t look as excited as I felt.</p>
<p class="indent">“Piper, stay with me,” Mom ordered.</p>
<p class="indent">I looked over at her and wanted to ask why. But the look on her face told me, <span class="txit">Don’t push me, young lady.</span> I’d seen that look lots of times.</p>
<p class="indent">Oh, wait . . . I bet I knew what was going on here. Mom didn’t want me to pet the dogs because she knew I’d want to take one home with us. I was just supposed to meet the nice person who owned this place, and then Mom would (maybe) take me for ice cream.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch02a.vue?2fdd7d26